module.exports = __webpack_public_path__ + "media/icons/pochodzenie-sprowadzony-blue-fde77191.png";